import { PurlivoBrowserContext } from './purlivo-browser-context';

/** Serializes native linked-account switches across tabs of the same origin and surface. */
export class PurlivoAccountSwitch {
    /** A held native switch owns recovery; queued/unrelated locks carry no authority. */
    static async isInProgress(): Promise<boolean> {
        if (!PurlivoBrowserContext.surface || !navigator.locks?.query) return false;
        try {
            const snapshot = await navigator.locks.query();
            const name = 'Purlivo.' + PurlivoBrowserContext.surface + '.AccountSwitch';
            return snapshot.held?.some(lock => lock.name === name && lock.mode === 'exclusive') ?? false;
        } catch {
            return false;
        }
    }

    static async run(action: () => Promise<void>): Promise<'completed' | 'busy' | 'stale' | 'unsupported'> {
        if (!PurlivoBrowserContext.check()) return 'stale';
        const locks = navigator.locks;
        if (!locks) return 'unsupported';
        return locks.request('Purlivo.' + PurlivoBrowserContext.surface + '.AccountSwitch',
            { mode: 'exclusive', ifAvailable: true }, async lock => {
                if (!lock) return 'busy';
                if (!PurlivoBrowserContext.check()) return 'stale';
                await action();
                return 'completed';
            });
    }
}
